"use client";

import React from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@heroui/react";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: "primary" | "success" | "warning" | "danger";
  icon?: string;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  confirmColor = "primary",
  icon = "solar:question-circle-bold",
}) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      backdrop="blur"
      classNames={{
        backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20",
      }}
      isOpen={isOpen}
      placement="center"
      onClose={onClose}
    >
      <ModalContent>
        <ModalHeader className="flex items-center gap-3">
          <Icon className="text-default-500" icon={icon} width={24} />
          <span>{title}</span>
        </ModalHeader>
        <ModalBody>
          <p className="text-default-600 whitespace-pre-line leading-relaxed">{message}</p>
        </ModalBody>
        <ModalFooter>
          <Button color="default" variant="light" onPress={onClose}>
            {cancelText || t("Cancel")}
          </Button>
          <Button color={confirmColor} onPress={handleConfirm}>
            {confirmText || t("Continue")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
